import React from "react";
import Pageheadr from "../../components/pageheader/Pageheader";
// import CreatePNR from "./Section/Addflight";
import useFetch from "../../hooks/useFetch";
import moment from "moment";
import AirportList from "./Section/Airportlist";
// import CreateCompany from "./Section/AddAirline";
import CreateAirport from "./Section/AddAirport";
import { API_URL } from "../../api/api";

export default function DatAirport() {
  const { data, loading, error } = useFetch(`${API_URL}/airport`);

  const getReadDate = (e) => {
    const timestamp = e;
    const formatted = moment(timestamp).format("DD/MM/YYYY | HH:mm");
    // const formatted = moment(timedtamp).format("DD/MM/YYYY ");
    return formatted;
  };

  return (
    <div className="">
      <Pageheadr
        CreatePNR={<CreateAirport />}
        name="Airline"
        btnName="ADD AIRPORT"
      />
      <AirportList data={data} />
    </div>
  );
}
